import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const NOTAMIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                d='M5.40002 19V5H8.66002L16.38 14.32H14.84V5H18.72V19H15.46L7.74002 9.68H9.28002V19H5.40002Z'
                fill='currentColor'
            />
        </>
    ),
})

NOTAMIcon.displayName = 'NOTAMIcon'
